<template>
  <history-template
    :expandable="false"
    :closable="true"
    @closeHistory="$emit('closeHistory')"
  >
    <template #histories>
      <div class="block margin-top-10">
        <el-timeline>
          <template v-for="action in histories">
            <!--hiển thị action log-->
            <template v-if="action.dataType === 'actionLog'">
              <ban-hanh-toi-history-item
                v-if="
                  action.actionName === ACTION_LOG_ACTION_NAME.BANHANH_TOI ||
                  action.actionName === ACTION_LOG_ACTION_NAME.BANHANHV2
                "
                :key="action.id"
                :action="action"
                @downloadFile="downloadFile"
              ></ban-hanh-toi-history-item>

              <doc-in-update-history-item
                v-if="
                  action.actionName ===
                  ACTION_LOG_ACTION_NAME.UPDATE_INCOMING_DOC
                "
                :key="action.id"
                :action="action"
                @downloadFile="downloadFile"
              ></doc-in-update-history-item>

              <doc-in-cho-y-kien-history-item
                v-if="action.actionName === ACTION_LOG_ACTION_NAME.CHOYKIEN"
                :key="action.id"
                :action="action"
                @downloadFile="downloadFile"
              ></doc-in-cho-y-kien-history-item>

              <doc-in-tltvb-status-history-item
                v-if="
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.HE_THONG_BAN_HANH ||
                  action.actionName ===
                    ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH
                "
                :key="action.id"
                :action="action"
                @downloadFile="downloadFile"
              ></doc-in-tltvb-status-history-item>

              <doc-in-history-item
                v-else
                :key="'doc-in-history-item-' + action.id"
                :action="action"
                @downloadFile="downloadFile"
              ></doc-in-history-item>
            </template>
            <!--hiển thị action log:end-->

            <!--hiển thị comment-->
            <comment-history-item
              v-else
              :key="action.id"
              :action="action"
              @downloadFile="downloadFile"
            ></comment-history-item>
            <!--hiển thị comment:end-->
          </template>
        </el-timeline>
      </div>
    </template>

    <template #footer>
      <template v-if="isEnableComment">
        <el-card class="comment-area">
          <div class="flex-row flex__left style-fullWidth">
            <i class="color__silver fas fa-user-circle"></i>
            <el-select
              ref="toUserSelectDropdown"
              class="input-none__border style-fullWidth toReceiver"
              v-model="toUserIds"
              placeholder="Chọn người nhận"
              size="medium"
              multiple
              filterable
              clearable
              @visible-change="toUserSelectDropdownVisibleChange"
            >
              <el-option
                v-for="item in toUsers"
                :key="item.id"
                :label="item.fullName"
                :value="item.id"
              >
                <p class="select-signer">
                  <span>
                    {{ item.fullName }}
                    <em class=""
                      >({{ item.positionName + " - " + item.deptName }})</em
                    >
                  </span>
                </p>
              </el-option>
            </el-select>
          </div>

          <el-input
            type="textarea"
            resize="none"
            ref="inputComment"
            :autosize="{ minRows: 3, maxRows: 10 }"
            placeholder="Nội dung bình luận"
            v-model="content"
            class="input-none__border style-fullWidth comment-input"
          >
          </el-input>

          <div class="action-comment flex-row flex__between margin-top-5">
            <!--            <div class="action-file">-->
            <el-tooltip placement="top" content="Tải file đính kèm">
              <el-upload
                ref="fileDialog"
                :action="uploadAttachmentURL"
                :headers="uploadAttachmentHeaders"
                :on-success="
                  (response) =>
                    onUploadSuccess(response).then((response) =>
                      uploadAttachmentSuccess(response)
                    )
                "
                :data="uploadAttachmentAdditionalData()"
                :show-file-list="false"
                :before-upload="
                  (file) => validateUploadFile(file, { acceptFileTypes: ['*'] })
                "
                :on-error="onUploadError"
                v-loading="isUploading"
              >
                <i class="fal fa-paperclip icon-action-comment clickable"></i>
              </el-upload>
            </el-tooltip>
            <!--            </div>-->

            <el-tooltip placement="top" content="Gửi" :class="{ 'button-disabled': isSubmitting }">
              <i
                class="fab fa-telegram-plane font-weight__bold font-size__large clickable color__blue"
                @click="insertComment"
              ></i>
            </el-tooltip>
          </div>

          <div
            v-if="vbAttachments"
            class="group-info el-upload-list el-upload-list--text"
          >
            <div
              v-for="vbAttachment in vbAttachments"
              :key="vbAttachment.id"
              class="flex-row flex__between file-item el-upload-list__item is-success"
            >
              <div class="flex-row flex__left">
                <a
                  v-openInNewTab
                  :href="
                    getToken(vbAttachment.id)
                      | buildAttachmentURL({
                        type: DOWNLOAD_OPTION.TYPE.ORIGINAL,
                      })
                  "
                  class="link-file"
                >
                  <fileTypeImage
                    :fileExtention="vbAttachment.fileExtention"
                    :customClass="'icon-mini'"
                  />
                  <span class="link-file clickable font-size__small">{{
                    vbAttachment.fileName
                  }}</span>
                </a>
              </div>
              &nbsp;
              <label class="el-upload-list__item-status-label">
                <i class="el-icon-upload-success el-icon-circle-check"></i>
              </label>
              <i
                class="el-icon-close el-tooltip item clickable font-size__small color__red"
                @click="removeVbAttachment(vbAttachment)"
              ></i>
            </div>
          </div>
        </el-card>
      </template>
    </template>
  </history-template>
</template>

<script>
import constants from "../../constants";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
import dateFormatter from "../../filters/dateFormatter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import actionLogService from "../../services/actionLogService";
import attachmentService from "../../services/attachmentService";
import downloadService from "../../services/downloadService";
import h from "../../services/h";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import utils from "../../services/utils";
import vbCommentService from "../../services/vbCommentService";
import vbCommentToUserViewService from "../../services/vbCommentToUserViewService.js";
import HistoryTemplate from "../adminstration/ketluan/history-template";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import ActionLogAttachments from "./actionLogAttachments";
import BanHanhToiHistoryItem from "./ban-hanh-toi-history-item";
import CommentHistoryItem from "./comment-history-item";
import DocInChoYKienHistoryItem from "./doc-in-cho-y-kien-history-item";
import DocInHistoryItem from "./doc-in-history-item";
import DocInReceiversInfo from "./doc-in-receivers-info";
import DocInTltvbStatusHistoryItem from "./doc-in-tltvb-status-history-item";
import DocInUpdateHistoryItem from "./doc-in-update-history-item";
import HistoryBanhanhtoi from "./history-banhanhtoi";
import HistoryChoYKien from "./history-cho-y-kien";
import HistoryStatusTltvb from "./history-status-tltvb";
import HistoryVbdenUpdate from "./history-vbden-update";
import uploadFileMixin from "./uploadFileMixin";

export default {
  name: "doc-in-histories-v2",
  mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
  props: [
    "vbIncomingDocId",
    "mainVbIncomingDocId",
    "subDocId",
    "isEnableComment",
  ],
  components: {
    DocInTltvbStatusHistoryItem,
    DocInChoYKienHistoryItem,
    DocInUpdateHistoryItem,
    BanHanhToiHistoryItem,
    CommentHistoryItem,
    DocInHistoryItem,
    DocInReceiversInfo,
    HistoryTemplate,
    HistoryChoYKien,
    HistoryStatusTltvb,
    HistoryVbdenUpdate,
    HistoryBanhanhtoi,
    ActionLogAttachments,
    fileTypeImage: () => import("../common/FileTypeImage"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    popoverWord: () => import("../common/popoverWord"),
  },
  filters: {
    dateFormatter,
    convertToLabelFilter,
    buildAttachmentURL,
  },

  watch: {
    // $route() {
    //   this.loadData();
    //   this.loadToUsers();
    // },

    vbIncomingDocId() {
      this.loadData();
    },

    mainVbIncomingDocId() {
      this.loadToUsers();
    },

    // isFullScreen() {
    //   return this.isFullScreen;
    // },

    isToUsersFocused(newValue) {
      this.isActiveToUsers = newValue || this.isToUserSelectDropdownVisible;
    },

    isToUserSelectDropdownVisible() {
      this.isActiveToUsers =
        this.isToUsersFocused || this.isToUserSelectDropdownVisible;
    },

    isActiveToUsers(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.toUserSelectDropdown.focus();
        });
      }
    },

    toUserIds(newValue) {
      this.selectedToUsers = h.collect(newValue, (toUserId) => {
        return h.find(this.toUsers, (toUser) => toUser.id === toUserId);
      });
    },
  },
  computed: {
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
  },

  data() {
    return {
      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      ACTION_LOG_ACTION_NAME: constants.ACTION_LOG_ACTION_NAME,
      vbAttachment: {},
      isFullScreen: false,
      form: {
        comment: "",
        listReceiver: [],
      },
      histories: [],
      toUserIds: [],
      toUsers: [],
      selectedToUsers: [],
      content: null,
      commentToUsers: [],
      actionLogs: [],
      comments: [],
      isToUsersFocused: false,
      isActiveToUsers: false,
      isToUserSelectDropdownVisible: false,
      vbAttachments: [],
      commentVbAttachments: [],
      userDeptRole: null,
      isSubmitting: false,
    };
  },

  created() {
    this.loadUserDeptRole()
      .then(() => this.loadData())
      .then(() => this.loadToUsers());
  },

  methods: {
    downloadFile({ vbAttachment }) {
      return downloadService.downloadFileForAttachmentComment(vbAttachment.id);
    },

    loadUserDeptRole() {
      return userDeptRoleViewService
        .findById(this.userDeptRoleId)
        .then((response) => (this.userDeptRole = response.data));
    },

    getProcessTypeName(processType) {
      switch (processType) {
        case constants.PROCESS_TYPE.CHUTRI:
          return "(Chủ trì)";
        case constants.PROCESS_TYPE.PHOIHOP:
          return "(Phối hợp)";
        case constants.PROCESS_TYPE.NHANDEBIET:
          return "(Nhận để biết)";
        default:
          return "";
      }
    },

    buildWordTemplate(action) {
      if (
        action.dataType === "actionLog" &&
        action.dataJson &&
        action.dataJson.length > 1
      ) {
        switch (action.actionName) {
          case "chuyenXuLiDonVi":
          case "banHanh":
            return ` và ${action.dataJson.length - 1} đơn vị khác`;
          default:
            return ` và ${action.dataJson.length - 1} người khác`;
        }
      } else {
        return "";
      }
    },

    buildNameReceivers(action) {
      if (
        action.actionName &&
        action.dataType === "actionLog" &&
        action.dataJson
      ) {
        // if response array people
        if (action.dataJson.length) {
          switch (action.actionName) {
            case "chuyenXuLi":
              return (
                action.dataJson[0].receiverName +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "chuyenXuLiDonVi":
              return (
                (action.dataJson[0].toDeptName ||
                  action.dataJson[0].deptReceiverName) +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "banHanh":
              return (
                (action.dataJson[0].deptName ||
                  action.dataJson[0].deptReceiverName) +
                " " +
                this.getProcessTypeName(action.dataJson[0].processType)
              );
            case "thuHoi":
              return (
                action.dataJson[0].receiverName ||
                action.dataJson[0].deptReceiverName
              );
            default:
              return "";
          }
        } else {
          // if dataJson is object and actionName is chuyenXuLi
          if (action.actionName === "chuyenXuLi")
            return action.dataJson.receiverName || "";
        }
      }
      return "";
    },

    removeVbAttachment(vbAttachment) {
      this.vbAttachments.splice(this.vbAttachments.indexOf(vbAttachment), 1);
    },

    uploadAttachmentAdditionalData() {
      return { objectType: constants.ATTACHMENT_OBJECT_TYPE.COMMENT };
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachments.push(vbAttachment);
    },

    loadToUsers() {
      return userDeptRoleViewService
        .findAll(
          {},
          {
            sort: ["positionOrder", "fullName"],
          }
        )
        .then((response) => (this.toUsers = response.data));
      // return userDeptRoleViewService
      //   .findAllByVbIncomingDoc(this.mainVbIncomingDocId)
      //   .then((response) => (this.toUsers = response.data));
    },

    loadData() {
      return this.loadActionLogs()
        .then(() => this.loadComments())
        .then(() => this.loadCommentToUsers(this.comments))
        .then((commentToUsers) => (this.commentToUsers = commentToUsers))
        .then(() => this.loadCommentVbAttachments(this.comments))
        .then((vbAttachments) => {
          this.commentVbAttachments = vbAttachments;
          this.mixToHistories();
        });
    },

    loadCommentVbAttachments(comments) {
      let commentIds = h.collect(comments, (comment) => comment.id);
      return commentIds && commentIds.length
        ? attachmentService
            .findAllByComments(commentIds, {
              sort: "createTime,desc",
              page: 0,
              size: 1000,
            })
            .then((response) => response.data)
        : new Promise((resolve) => resolve([]));
    },

    loadCommentToUsers(comments) {
      let commentIds = h.collect(comments, (comment) => comment.id);
      return commentIds && commentIds.length
        ? vbCommentToUserViewService
            .findAll(
              null,
              { sort: "createTime,desc", page: 0, size: 1000 },
              commentIds
            )
            .then((response) => response.data)
        : new Promise((resolve) => resolve([]));
    },

    loadComments() {
      return vbCommentService
        .findAllBySenderIdOrReceiverId(
          this.vbIncomingDocId,
          constants.COMMENT_OBJECT_TYPE.VB_DEN,
          { sort: "createTime,desc", page: 0, size: 1000 }
        )
        .then((response) => (this.comments = response.data));
    },

    loadActionLogs() {
      // console.log(this.userDeptRole.roleCode);
      // if (this.userDeptRole.roleCode === "vanthu")
      return actionLogService
        .findAllByVbIncomingDoc(this.vbIncomingDocId, this.subDocId, {
          sort: "createTime,desc",
          page: 0,
          size: 1000,
        })
        .then((response) => (this.actionLogs = response.data));
      // else
      //   return actionLogService
      //     .findAllAccessible(this.vbDocProcessId, {
      //       sort: "createTime,desc",
      //       page: 0,
      //       size: 1000
      //     })
      //     .then(response => (this.actionLogs = response.data));
    },

    changeView() {
      this.isFullScreen = !this.isFullScreen;
    },

    insertComment() {
      if (this.isSubmitting)  {
        this.$message({
          message: "Đang gửi bình luận, vui lòng đợi...",
          type: "info",
        });
        return;
      }

      /**
       * validate comment;
       */
      if (!this.content || !this.content.trim()) {
        this.$message({
          message: "Nội dung bình luận chưa được nhập",
          type: "error",
        });
        return;
      }

      if (!this.selectedToUsers || !this.selectedToUsers.length) {
        this.$message({
          message: "Chưa có người nhận được chọn",
          type: "error",
        });
        return;
      }

      this.isSubmitting = true;
      let vbCommentToUserForms = h.collect(this.selectedToUsers, (item) => {
        return {
          userId: item.userId,
          deptId: item.deptId,
          roleId: item.roleId,
          positionId: item.positionId,
          userDeptRoleId: item.id,
        };
      });
      let attachmentIds = h.collect(this.vbAttachments, (item) => item.id);

      vbCommentService
        .insert({
          objectId: this.vbIncomingDocId,
          objectType: constants.COMMENT_OBJECT_TYPE.VB_DEN,
          content: this.content,
          vbCommentToUserForms: vbCommentToUserForms,
          attachmentIds: attachmentIds,
        })
        .then((response) => {
          let comment = response.data;

          /**
           * reset lại form nhập comment;
           */
          this.isActiveToUsers = false;
          this.content = "";
          this.toUserIds = [];
          this.vbAttachments = [];
          this.isSubmitting = false;

          this.comments.push(comment);
          this.loadCommentToUsers([comment]).then((commentToUsers) => {
            this.loadCommentVbAttachments([comment]).then((vbAttachments) => {
              /**
               * binding lại danh sách lịch sử, không query lại toàn bộ ảnh hưởng tới performance;
               */
              this.commentToUsers.push(...commentToUsers);
              this.commentVbAttachments.push(...vbAttachments);
              this.histories.splice(
                0,
                0,
                this.convertCommentToHistory(comment)
              );
            });
          });
        })
        .catch((error) => this.commonHandleRequestError(error));
    },

    toUserSelectDropdownVisibleChange(event) {
      this.isToUserSelectDropdownVisible = event;
    },

    buildShortName(fullName) {
      return utils.buildShortName(fullName);
    },

    buildActionLabel(history) {
      if (history.dataType == "actionLog") {
        switch (history.actionName) {
          case constants.ACTION_LOG_ACTION_NAME.INSERT:
            return "Tạo mới";
          case constants.ACTION_LOG_ACTION_NAME.UPDATE:
            return "Cập nhật";
          case constants.ACTION_LOG_ACTION_NAME.UPDATE_INCOMING_DOC:
            return "Sửa sai";
          case constants.ACTION_LOG_ACTION_NAME.CHUYENXULI:
            return "Chuyển xử lý đến";
          case constants.ACTION_LOG_ACTION_NAME.CHOBANHANH:
            return "Duyệt ban hành";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOI:
            return "Từ chối";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
            return "Từ chối tiếp nhận";
          case constants.ACTION_LOG_ACTION_NAME.BANHANH:
            return "Ban hành văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.KETTHUC:
            return "Kết thúc";
          case constants.ACTION_LOG_ACTION_NAME.THUHOI:
            return "Thu hồi văn bản từ";
          case constants.ACTION_LOG_ACTION_NAME.CHUYENXULI_DONVI:
            return "Chuyển xử lý đến";
          case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
            return "Từ chối";
          default:
            return history.actionName;
        }
      } else {
        return "";
      }
    },

    loadCommentAttachment_(item) {
      item.attachments = h.findAll(
        this.commentVbAttachments,
        (vbAttachment) => vbAttachment.objectId === item.data.id
      );
    },

    loadCommentToUsers_(item) {
      item.toUsers = h.findAll(
        this.commentToUsers,
        (commentToUser) => commentToUser.commentId === item.data.id
      );
    },

    convertCommentToHistory(item) {
      var history = {
        actionName: item.actionName,
        creatorName: item.fromFullName || item.fromUserName,
        creatorId: item.fromUserId,
        createTime: item.createTime,
        dataType: "comment",
        data: item,
      };

      history.actionNameLabel = this.buildActionLabel(history);

      this.loadCommentAttachment_(history);
      this.loadCommentToUsers_(history);

      return history;
    },

    mixToHistories() {
      var histories = (this.histories = []);

      h.each(this.actionLogs, (item) => {
        var history = {
          actionName: item.actionName,
          creatorName: item.creatorName,
          creatorId: item.creatorId,
          createTime: item.createTime,
          dataType: "actionLog",
          data: item,
          dataJson: item.hasOwnProperty("dataJson")
            ? JSON.parse(item.dataJson)
            : "",
        };

        history.actionNameLabel = this.buildActionLabel(history);

        histories.push(history);
      });

      h.each(this.comments, (item) => {
        histories.push(this.convertCommentToHistory(item));
      });

      histories.sort((item1, item2) =>
        item1.createTime > item2.createTime
          ? -1
          : item1.createTime < item2.createTime
          ? 1
          : 0
      );
    },

    classIconByActionName(actionName) {
      return actionName == "update"
        ? "fal fa-pencil-alt"
        : actionName == "insert"
        ? "fal fa-file-plus"
        : actionName == "chuyenXuLi"
        ? "far fa-arrow-alt-circle-right"
        : actionName == "banHanh"
        ? "fal fa-check-circle"
        : actionName == "tuChoi"
        ? "fal fa-times-octagon"
        : actionName == "tuChoiTiepNhan" || actionName == "lanhDaoTuChoi"
        ? "fal fa-times-octagon"
        : actionName == "choBanHanh"
        ? "fal fa-clock"
        : actionName == "kethuc"
        ? "fal fa-calendar-check"
        : actionName == "thuHoi"
        ? "fal fa-undo"
        : actionName == "thuHoiBanHanh"
        ? "fas fa-reply-all"
        : actionName == "chuyenXuLiDonVi"
        ? "far fa-arrow-alt-circle-right"
        : "";
    },

    classColorByActionName(actionName) {
      //mockup chuyen vien van thu tu choi
      // action.actionName = 'chuyenVienTuChoi'
      //   ? 'font-size__small color__red fal fa-reply'
      //   : ''
      return actionName === "update"
        ? "color__green"
        : actionName === "insert"
        ? "color__blue"
        : actionName === "chuyenXuLi"
        ? "color__cyan"
        : actionName === "banHanh"
        ? "color__blue"
        : actionName === "tuChoi"
        ? "color__red"
        : actionName === "tuChoiTiepNhan" || actionName === "lanhDaoTuChoi"
        ? "color__red"
        : actionName === "choBanHanh"
        ? "color__blue"
        : actionName === "kethuc"
        ? "color__green"
        : actionName === "thuHoi"
        ? "color__yellow"
        : actionName === "thuHoiBanHanh"
        ? "color__blue"
        : actionName === "chuyenXuLiDonVi"
        ? "color__blue"
        : "";
    },
  },
};
</script>

<style scoped>
.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/doc-in-histories-v2.vue